import * as React from "react";
import {
    TabStrip,
    TabStripSelectEventArguments,
    TabStripTab,
} from "@progress/kendo-react-layout";

import ProductsCategory from "./ProductsCategory";

const Products = () => {

    const examTabStripRef = React.useRef<any>(null);
    const [selectedTab, setSelectedTab] = React.useState<number>(0);
    const [tabStripHeight, setTabStripHeight] = React.useState<string>("600px");

    React.useEffect(() => {
        window.addEventListener("resize", handleResize);
    }, []);
    React.useEffect(() => {
        setTabStripHeight((window.innerHeight - 90) + "px");
    }, );

    const handleResize = () => {
        setTabStripHeight((window.innerHeight - 90) + "px");
    };

    const handleSelectTab = (e: TabStripSelectEventArguments) => {
        setSelectedTab(e.selected);
        if (examTabStripRef && examTabStripRef.current && examTabStripRef.current._element && examTabStripRef.current._element.children)
            examTabStripRef.current._element.children[1].scrollTop = 0;
    };

    const ExamForm = React.useRef<any>(null);

    return (
        <React.Fragment>
            <div style={{ marginBottom: "0px" }} className="sds-gridHeader">Products</div>
            <div>
            <TabStrip
                ref={examTabStripRef}
                selected={selectedTab}
                onSelect={handleSelectTab}
                keepTabsMounted={false}
                    animation={true}
                    scrollable={true }
                style={{ paddingTop: "4px", height: tabStripHeight }}
                    className={"sds-window"}>

                    <TabStripTab title="Antibiotics">
                        <ProductsCategory category={1} />
                    </TabStripTab>
                    <TabStripTab title="Calming">
                        <ProductsCategory category={2} />
                    </TabStripTab>
                    <TabStripTab title="Cleaning">
                        <ProductsCategory category={3} />
                    </TabStripTab>
                    <TabStripTab title="Dental">
                        <ProductsCategory category={4} />
                    </TabStripTab>
                    <TabStripTab title="Ears">
                        <ProductsCategory category={5} />
                    </TabStripTab>
                    <TabStripTab title="Eyes">
                        <ProductsCategory category={6} />
                    </TabStripTab>
                    <TabStripTab title="IV Solutions">
                        <ProductsCategory category={7} />
                    </TabStripTab>
                    <TabStripTab title="Nutraceutical">
                        <ProductsCategory category={8} />
                    </TabStripTab>
                    <TabStripTab title="Pain Mgmt">
                        <ProductsCategory category={9} />
                    </TabStripTab>
                    <TabStripTab title="Parasiticides">
                        <ProductsCategory category={10} />
                    </TabStripTab>
                    <TabStripTab title="Pharmacy">
                        <ProductsCategory category={11} />
                    </TabStripTab>
                    <TabStripTab title="Skin">
                        <ProductsCategory category={12} />
                    </TabStripTab>
                    <TabStripTab title="Vaccines">
                        <ProductsCategory category={13} />
                    </TabStripTab>

            </TabStrip>
        </div>
       </React.Fragment>
    );
};
export default Products;
